import VehicleManufacturerContainer from "../VehicleManufacturer/VehicleManufacturerContainer";
import VehicleManufacturerStore from "./VehicleManufacturerStore";

export default VehicleManufacturerStore(VehicleManufacturerContainer);
